import {AppForm} from "../../../../../../../common/forms/app.form";
import {Injectable} from "@angular/core";
import {FormControl, Validators} from "@angular/forms";
import {CustomValidator} from "../../../../../../../common/forms/custom.validators";
import {ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite} from "../../../../../../../openapi";
import {toNumber} from "../../../../../../../services/helpers";

@Injectable()
export class RealEstateLeasingBaseInfoForm extends AppForm {

  public leasePurposeList: string[] = [
    'Działalność gospodarcza',
    'Uprawa ogródka warzywnego',
    'Użytkowania pobudowanego na gruncie obiektu',
    'Użytkowanie tymczasowego garażu na gruncie gminnym',
    'Inne'
  ];

  constructor() {
    super({
      leasePurpose: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),

      startDate: new FormControl(null, {validators: [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.minDate(new Date())]}),
      endDate: new FormControl(null, {validators: [Validators.required, CustomValidator.isValidDateFormat()]}),
      city: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.maxLength(255)]}),
      street: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.maxLength(255)]}),
      registrationNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      area: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.maxLength(255)]}),
    });
  }

  public get description(): FormControl | null {
    return this.get('description') as FormControl | null;
  }

  public leasePurposeChange(v: string): void {
    if (v === 'Inne') {
      this.addControl('description', new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }))
    } else {
      this.removeControl('description');
    }
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      area: toNumber(this.value.area)
    };
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    this.leasePurposeChange(value?.leasePurpose || '')
    super.patchFormValues({
      ...value
    });
  }
}
